import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {ArticleGroupsListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ArticleGroupsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ArticleGroupsListItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
	);

	return result;
}

// @note There is no output function since list is read only.